import React from 'react';

import { EntityListHeader } from 'src/v2/features/sharedEntity/components/EntityListHeader';
import i18n from 'src/i18n';
import { translationKeys } from 'src/common/translations';

export const ListHeader: React.FC = () => (
  <EntityListHeader plusTitle={i18n(translationKeys.headerMenu.newTemplate)} />
);
